import React, { useState, useEffect, useRef } from 'react';

const AnimatedCounter = ({
  end,
  duration = 2000,
  prefix = '',
  suffix = '',
  className = '',
  startOnView = true
}) => {
  const [count, setCount] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const counterRef = useRef(null);

  useEffect(() => {
    let observer;

    if (startOnView && counterRef.current) {
      observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !hasAnimated) {
            startAnimation();
          }
        },
        { threshold: 0.1 }
      );

      observer.observe(counterRef.current);
    } else if (!startOnView && !hasAnimated) {
      startAnimation();
    }

    return () => {
      if (observer && counterRef.current) {
        observer.unobserve(counterRef.current);
      }
    };
  }, [hasAnimated, startOnView]);

  const startAnimation = () => {
    if (hasAnimated) return;

    setHasAnimated(true);
    const startTime = Date.now();
    const startValue = 0;

    const animate = () => {
      const now = Date.now();
      const progress = Math.min((now - startTime) / duration, 1);

      // Easing function for smooth animation (ease-out)
      const easeOut = 1 - Math.pow(1 - progress, 3);
      const currentValue = Math.floor(startValue + (end - startValue) * easeOut);

      setCount(currentValue);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setCount(end); // Ensure we end exactly at the target
      }
    };

    requestAnimationFrame(animate);
  };

  const formatNumber = (num) => {
    return num.toLocaleString('es-ES');
  };

  return (
    <span ref={counterRef} className={className}>
      {prefix}{formatNumber(count)}{suffix}
    </span>
  );
};

export default AnimatedCounter;